<template>
  <div v-cloak class="crowdfunding">
    <div v-title :data-title="detail.Name"></div>
    <!-- 中间内容 -->
    <div class="container pa-b-20 bg-fff">
      <div class="pa-t-20 pa-b-20"><Bread :list="breadList" /></div>
      <el-row type="flex" justify="space-between" class="f-wrap">
        <el-col :xs="24" :sm="14" class="">
          <div class="item-box">
            <img :src="detail.Cover" alt="" srcset="" class="item-img" />
          </div>
        </el-col>
        <el-col :xs="24" :sm="10" class="pa-20">
          <div class="font-bold fon-24 w-w-b-a" :title="detail.Name">
            {{ detail.Name }}
          </div>
          <div class="c-red font-bold ma-t-10">
            已众筹￥{{ detail.GetAmount }}
          </div>
          <div class="progress-box ma-t-10">
            <div
              class="progress-line"
              :style="{ width: getProgress(detail) }"
            ></div>
          </div>
          <div class="flex f-between ma-t-10">
            <div class="c-666">目标金额：￥{{ detail.Amount }}</div>
            <div>{{ getProgress(detail) }}</div>
          </div>
          <div class="flex">
            <div v-if="detail.Status">
              <div class="fon-24 font-bold ma-t-10">
                {{ getSurplus(detail.EndTime) }}天
              </div>
              <div class="c-666">剩余时间</div>
            </div>
            <div class="ma-l-40">
            <div class="fon-24 font-bold ma-t-10">{{ detail.PayCount }}人</div>
            <div class="c-666">支持人数</div>
          </div>
          </div>
          <div class="t-center">
            <a class="btn-support ma-t-40" href="#support" v-if="detail.Status"
              >立即支持</a
            >
            <a class="btn-support ma-t-40" v-else>已结束</a>
            <div class="ma-t-10 c-666 fon-12">
              *此项目将在{{ detail.EndTime }}结束
            </div>
            <div v-if="!isWeixin">
              <div class="t-center font-bold">分享项目到</div>
              <div class="flex f-jcenter width100 ma-t-20">
                <div class="share-icon" @click="copyToClip()" title="复制链接">
                  <i class="iconfont icon-lianjie"></i>
                </div>
                <div
                  class="share-icon ma-lr-20"
                  @click="shareQQ()"
                  title="分享到QQ空间"
                >
                  <i class="iconfont icon-qqkongjian"></i>
                </div>
                <div class="share-icon" @click="shareWEB()" title="分享到微博">
                  <i class="iconfont icon-weibo"></i>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="container bg-fff">
      <div class="ma-t-30 bg-fff pa-20">
        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="项目详情" name="0"></el-tab-pane>
            <el-tab-pane label="评论" name="1"></el-tab-pane>
            <el-tab-pane label="支持者" name="2"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="flex f-between">
          <div class="width70">
            <div v-if="activeName == 0">
              <div class="b-b-1-e3 fon-24 font-bold pa-b-10">项目详情</div>
              <div class="lh-html" v-html="detail.Detail"></div>
            </div>

            <div v-if="activeName == 1">
              <Comment
                :list="commentList"
                :pageIndex="pageIndex"
                :totals="totals"
                :id="id"
                @changeComent="getComment"
              ></Comment>
            </div>

            <div v-if="activeName == 2">
              <div>
                <div class="font-bold fon-22 b-b-1-e3 pa-b-20">
                  支持者{{ supportList.length }}
                </div>
                <div class="ma-t-30">
                  <div
                    v-for="(item, index) in supportList"
                    :key="index"
                    class="flex ma-b-30 f-center"
                  >
                    <img
                      :src="item.HeadImage"
                      alt=""
                      srcset=""
                      class="support-img width10"
                    />
                    <div class="width90">
                      <span class="ma-l-20 fon-22 font-bold">{{
                        item.MemberName
                      }}</span>
                      <span class="c-666 ma-l-40"
                        >已支持{{ item.ProjectCount }}个项目</span
                      >
                    </div>
                  </div>
                </div>
                <div class="fy t-center">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :hide-on-single-page="true"
                    :current-page="supportPageIndex"
                    :page-size="10"
                    layout="prev, pager, next, jumper"
                    :total="supportTotals"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
          <div class="width30 pa-l-20">
            <a name="support"></a>
            <div
              v-for="(item, index) in detail.AmountList"
              :key="index"
              class="ma-b-40"
            >
              <div class="b-b-1-e3 fon-24 font-bold pa-b-10">
                {{ item.Name }}
              </div>
              <div class="c-666 ma-t-10">{{ item.Summary }}</div>
              <div class="btn-support-2 ma-t-10" @click="btnSupport(item.Id)">
                立即支持
              </div>
              <div class="flex f-between ma-t-10 f-wrap">
                <div class="font-bold fon-20">￥{{ item.Price }}</div>
                <div class="c-666">已支持{{ item.PayCount }}份</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .item-img {
    height: auto !important;
  }
}
.share-icon {
  width: 40px;
  height: 40px;
  background: #8a8a8a;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  color: #fff;
  cursor: pointer;
}
.support-img {
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
.w-w-b-a {
  word-break: break-all;
}
.c-red {
  color: #fb004d;
}
.container {
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
}
.progress-box {
  width: 100%;
  height: 6px;
  background: rgb(219, 219, 219);
  .progress-line {
    height: 100%;
    background: #fb004d;
  }
}
.item-box {
  background: #fff;
  .item-img {
    width: 100%;
    height: 520px;
  }
}
.btn-support {
  padding: 10px 70px;
  background: #fb004d;
  display: inline-block;
  color: #fff;
  cursor: pointer;
}
.btn-support-2 {
  padding: 6px 26px;
  background: #fb004d;
  display: inline-block;
  color: #fff;
  cursor: pointer;
}
</style>
<style lang="scss">
.crowdfunding {
  .el-tabs__header {
    display: flex;
    justify-content: center;
  }
  .el-tabs__content {
    min-width: 1080px;
    margin: 0 auto;
  }
  .el-tabs__item {
    padding: 0 60px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }
  .el-tabs__active-bar {
    height: 4px;
    font-weight: bold;
    background: #fb004d;
  }
  .is-active {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #fb004d;
  }
  .el-tabs__content {
    margin-top: 45px;
  }
}
</style>
    <script>
import {
  getCrowdFundingDetail,
  getCrowdFundingCommentList,
  getCrowdFundingPayList,
  getJsApiConfig
} from '../../api.js'
import Bread from '../../components/Bread.vue'
import Comment from './comment.vue'
import wx from 'weixin-js-sdk'
// studycollect
export default {
  components: { Bread, Comment },
  data() {
    return {
      id: '0',
      detail: {},
      breadList: [
        { name: '众筹列表', path: '/crowdfunding/list' },
        { name: '众筹详情' }
      ],
      activeName: 0,
      commentList: [], //评论数据
      pageIndex: 1, //评论分页
      totals: 0,
      supportList: [],
      supportTotals: 0,
      supportPageIndex: 0,
      isWeixin: false
    }
  },
  // 其他页面进来时更新初始数据
  activated() {
    this.id = this.$route.query.id
    //判断是否在微信浏览器里，如果在微信支付时使用微信支付，否则使用扫码支付
    var ua = navigator.userAgent.toLowerCase()
    this.isWeixin = ua.indexOf('micromessenger') != -1
    this.getList()
    this.getComment()
    this.getPayList()
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0)

    next()
  },

  methods: {
    //自定义分享
    setShartMesage() {
      var _this = this
      getJsApiConfig({
        url: location.href
      }).then((res) => {
        console.log(res.data.Data)
        if (res.data.Code == 0) {
          let weixin = res.data.Data
          wx.config({
            debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
            appId: weixin.AppId, // 必填，公众号的唯一标识
            timestamp: weixin.Timestamp, // 必填，生成签名的时间戳
            nonceStr: weixin.NonceStr, // 必填，生成签名的随机串
            signature: weixin.Signature, // 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的 JS 接口列表
          })
          wx.ready(function () {
            //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
              title: _this.detail.Name, // 分享标题
              desc: _this.detail.Summary, // 分享描述
              link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
              imgUrl: _this.detail.Cover, // 分享图标
              success: function () {
                // 设置成功
              }
            })
            wx.updateTimelineShareData({
              title: _this.detail.Name, // 分享标题
              link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
              imgUrl: _this.detail.Cover, // 分享图标
              success: function () {
                // 设置成功
              }
            })
          })
        } else {
          this.$message({
            message: res.data.Message,
            type: 'warning'
          })
        }
      })
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },

    //复制链接
    copyToClip(message) {
      var aux = document.createElement('input')
      aux.setAttribute('value', location.href)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      if (message == null) {
        alert('复制成功')
      } else {
        alert(message)
      }
    },
    //分享到qq空间
    shareQQ() {
      var query = {
        title: this.detail.Name,
        summary: this.detail.Summary,
        url: location.href,
        pics: this.detail.Cover
      }
      let url =
        'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?' +
        this.buildUrlQuery(query)
      window.open(url)
    },
    //分享到微博
    shareWEB() {
      var query = {
        title: this.detail.Name,
        summary: this.detail.Summary,
        url: location.href,
        pics: this.detail.Cover
      }
      let url =
        'http://service.weibo.com/share/share.php?' + this.buildUrlQuery(query)
      window.open(url)
    },
    //拼接url
    buildUrlQuery(query) {
      var queryItems = []
      for (var k in query) {
        queryItems.push(k + '=' + encodeURIComponent(query[k] || ''))
      }
      return queryItems.join('&')
    },
    //支持者列表
    getPayList() {
      getCrowdFundingPayList({
        pageSize: 10,
        pageIndex: this.pageIndex,
        id: this.id
      }).then((res) => {
        this.supportList = res.data.Data.List
        this.supportTotals = res.data.Data.TotalCount
      })
    },
    //获取评论
    getComment(o) {
      console.log(o)
      if (o && o.pageIndex) {
        this.pageIndex = o.pageIndex
      }
      getCrowdFundingCommentList({
        pageSize: 10,
        pageIndex: this.pageIndex,
        id: this.id
      }).then((res) => {
        this.commentList = res.data.Data.List
        this.totals = res.data.Data.TotalCount
      })
    },
    //支持
    btnSupport(id) {
      this.$router.push({
        path: '/crowdfunding/pay-1',
        query: { projectId: this.id, amountId: id }
      })
    },
    //tabs切换
    handleClick(e) {
      console.log(e.index)
    },
    //获取进度
    getProgress(item) {
      return ((item.GetAmount * 100) / item.Amount).toFixed(2) + '%'
    },
    //获取剩余时间
    getSurplus(endTime) {
      let nowTime = new Date()
      endTime = new Date(endTime)
      let sub = endTime - nowTime
      return Math.trunc(sub / (1000 * 60 * 60 * 24))
    },
    getList() {
      // let token = localStorage.getItem("AccessToken");
      // console.log(data);
      getCrowdFundingDetail({
        id: this.id
      }).then((res) => {
        if (res.data.Code == 0) {
          this.detail = res.data.Data
          document.title = this.detail.Name
          this.setShartMesage()
        }
      })
    },
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.supportPageIndex = e
    }
  }
}
</script>
    